import { ReactElement } from 'react'
import { TextField } from '@calabriocloud/beacon-ui'
import { useTranslation } from 'react-i18next'
import { FormSection, FormHeader } from './layout'
import { FormikErrors, FormikTouched, useFormikContext, ErrorMessage } from 'formik'
import { Goal } from '../../constants'
interface NameSectionProps {
  values: Goal,
  errors: FormikErrors<Goal>,
  touched: FormikTouched<Goal>,
  handleChange: (e: React.ChangeEvent<Element>) => void,
  handleBlur: (e: React.FocusEvent<Element>) => void,
}
export const NameSection = ({
  handleBlur,
}: NameSectionProps): ReactElement => {
  const { t } = useTranslation()
  const formik = useFormikContext<Goal>()
  const { name } = formik.values
  const { isDisabled, isSubmitting } = formik.status
  const handleChange = (value: string) => {
    formik.setFieldValue('name', value)
  }

  return (
    <FormSection>
      <FormHeader
        title={t('Name')}
        description={t('goalNameDescription')}
      />
      <TextField
        data-testid="name-input"
        className="max-w-xs"
        label={t('Name')}
        value={name}
        id="name"
        name="name"
        isDisabled={isDisabled || isSubmitting} // Disable field during submission
        maxLength={50}
        onBlur={handleBlur}
        onChange={handleChange}
      />
      <ErrorMessage name='name'>
        {errorMessage  => <div className="text-red-500 text-sm mt-2"> {errorMessage}</div>}
      </ErrorMessage>
    </FormSection>
  )
}
